import { nanoid } from 'nanoid';
import { syncAction } from '@/lib/action';

export const completeAction = syncAction('@router/COMPLETE');
export const noLocationChange = syncAction('@router/noLocationChange');
export const completeResetAction = syncAction('@router/COMPLETE_RESET', () => ({ payload: nanoid(8) }));
export const completeEmptyAction = syncAction('@router/COMPLETE_EMPTY', () => ({ payload: nanoid(8) }));
export const updateQueryAction = syncAction('@router/UPDATE_QUERY');
export const redirectAction = syncAction('@router/REDIRECT');
export const setRouteCompanyIdAction = syncAction<string | null>('@router/SET_ROUTE_COMPANY_ID');
